<template>
    <v-dialog v-model="dialog" max-width="350">
        <v-card>
            <v-card-title class="subtitle-1 font-weight-light">
                <v-icon>{{icons.video}}</v-icon>
                Add Video to Profile
            </v-card-title>
            <v-card-text>
                <v-list v-if="profiles && profiles.length===1">
                    <v-list-item @click="selectItem(profiles[0])">
                        <v-list-item-avatar>
                            <v-img :src="profiles[0].profilepic"/>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            {{profiles[0].firstname}} {{profiles[0].lastname}}
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-select
                        v-if="profiles&&profiles.length<10&&profiles.length>1"
                        ref="select"
                        outlined
                        label="Select Profile to Add"
                        dense
                        :items="profiles"
                        v-model="activeprofile"
                >
                    <template v-slot:item="{ item }">
                        <v-list-item @click="selectItem(item)">
                            <v-list-item-avatar>
                                <v-img :src="item.profilepic"/>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                {{item.firstname}} {{item.lastname}}
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                    <template v-slot:selection="{ item }">
                        <v-list-item @click="selectItem(item)">
                            <v-list-item-avatar>
                                <v-img :src="item.profilepic"/>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                {{item.firstname}} {{item.lastname}}
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-select>
                <div v-if="!activeprofile">
                    <v-text-field
                         dense
                         outlined
                         clearable
                         v-model="search"/>
                    <v-list v-if="searched">
                        <v-list-item v-for="p in searched" @click="selectItem(p)">
                            <v-list-item-avatar>
                                <v-img :src="p.profilepic"/>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                {{p.firstname}} {{p.lastname}}
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </div>
                <v-list v-if="activeprofile" class="py-0">
                    <v-list-item>
                        <v-list-item-avatar>
                            <v-img :src="activeprofile.profilepic"/>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            {{activeprofile.firstname}} {{activeprofile.lastname}}
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-btn icon @click="activeprofile=undefined,search=''">
                                <v-icon>mdi-rotate-left</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
                <v-text-field
                        dense
                        label="Video Title/Description"
                        v-model="videotitle"
                        required
                        type="textarea"
                ></v-text-field>

                <p>Describe YOU to the viewer.. jersey color.. number, etc...</p>
                <v-text-field
                        dense
                        label="Where are you? "
                        v-model="videome"
                        required
                        type="textarea"
                ></v-text-field>


            </v-card-text>
            <v-card-actions>
                <v-btn text small @click="Close()">
                    Cancel
                </v-btn>
                <v-spacer/>
                <v-btn text small :loading="loading" @click="addtoprofile()">
                    Add
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "AddVideoToProfile",
    props: ['dialog'],
    components: {},
    data() {
      return {
        videome: undefined,
        videotitle: undefined,
        activeprofile: undefined,
        loading: false,
        thumburl: 'https://videos.athleteforlife.org/',
        videourl: 'https://videos.athleteforlife.org/',
        search: undefined,
        searched: []
      }
    },
    computed: {
      ...mapState(['icons', 'myathletes', 'activevideo', 'sportcode']),
      profiles() {
        return this.myathletes
      }
    },
    watch: {
      search() {
        this.filterProfiles()
      }
    },
    methods: {
      ...mapActions(['get', 'put', 'selectPlayer']),
      selectItem(t) {
        this.$nextTick(() => {
          this.activeprofile = t
          if (this.$refs.select) {
            this.$refs.select.blur()
          }
        })
      },
      async addtoprofile() {
        //add video to player profile
        this.loading = true;
        let data = {
          partkey: this.activeprofile.partkey,//select one and clean it up
          playerurl: this.activeprofile.partkey,
          sport: this.sportcode,
          videoname: this.activevideo.sortkey,
          val: {
            partkey: this.activevideo.partkey,
            sortkey: this.activevideo.sortkey,
            thumb: this.thumburl + this.activevideo.info.thumb,
            url720p: this.videourl + this.activevideo.info.url720p,
            videome: this.videome,
            videotitle: this.videotitle
          }
        }
        let res = await this.put({path: 'api/profilesv2/profilevideo', body: data})
        console.log(res)
        this.loading = false
        this.Close()
        this.selectPlayer(this.activeprofile.partkey)
      },
      filterProfiles() {
        if (this.search === '') {
          this.searched = [];
          return
        }
        this.searched = this.profiles.filter(f => {
          return f.firstname.includes(this.search) || f.lastname.includes(this.search)
        })
      },
      Close() {
        this.videome = undefined
        this.videotitle = undefined;
        this.activeprofile = undefined;
        this.loading = false;
        this.search = undefined;
        this.searched = [];
        this.$emit('close', true)
      }
    }
  }

</script>

<style scoped>

</style>